import e from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import h from "./iconfont.es5471.js";
const i = {
  display: "block"
}, v = ({ size: t = 16, useVw: o, useRem: c, color: n, withColor: a, removeClassName: d, disableSSR: f, style: l, ...m }) => {
  const p = l ? { ...i, ...l } : i;
  return /* @__PURE__ */ e.createElement(h, { disableSSR: f }, /* @__PURE__ */ e.createElement("svg", { "data-icon-id": "icon-Linkedin-24px", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 24 24", width: o ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (c ? "rem" : "px"), height: o ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (c ? "rem" : "px"), className: d ? "" : "iconpark-icon", style: p, fill: "none", ...m }, /* @__PURE__ */ e.createElement(
    "g",
    {
      clipPath: "url(#1258ea__a)"
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fill: a ? r(n, 0, "currentColor") : "currentColor",
        datafollowfill: a ? r(n, 0, "currentColor") : "currentColor",
        d: "M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455l-.001 6.286ZM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065Zm1.782 13.019H3.555V9h3.564v11.452ZM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003Z"
      }
    )
  ), /* @__PURE__ */ e.createElement(
    "defs",
    null
  ), /* @__PURE__ */ e.createElement(
    "clipPath",
    {
      id: "1258ea__a"
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fill: a ? r(n, 1, "#fff") : "#fff",
        d: "M0 0h24v24H0z"
      }
    )
  )));
}, k = v;
export {
  k as default
};
